import styled from 'styled-components';

export const StepEbonComponentContainer = styled.div`
    .title {
        font-size: 14px;
    }

    .step-how-where-container {
        display: flex;
        flex-wrap: wrap;

        .step {
            flex: 1;
            max-width: 195px;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 10px;

            & > p {
                font-size: 12px;
                text-align: center;
            }

            .step-icon {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: ${props => props.theme.black};
                border-radius: 50%;
                height: 52px;
                width: 52px;

                & > span {
                    color: ${props => props.theme.white};
                    font-size: 20px;
                    font-weight: bold;
                }
            }
        }
    }

    .step-chevron {
        display: flex;
        width: 20%;

        span.isvg.hidden {
            z-index: -1;
        }

        & > span > svg {
            margin-top: 25px;

            path {
                stroke: ${props => props.theme.lightGrey};
            }
        }
    }

    @media (min-width: ${props => props.theme.medium}) {
        .step-how-where-container {
            flex-wrap: nowrap;
        }
    }

    @media (max-width: ${props => props.theme.mobile}) {
        .step-how-where-container {
            .step {
                max-width: initial;

                p {
                    margin-top: 20px;
                }
            }
        }

        .step-chevron {
            width: auto;
            flex-direction: column;

            span.isvg {
                text-align: center;
                padding: 10px 0;

                &.hidden {
                    display: none;
                }
            }

            & > span > svg {
                margin-top: 0;
                transform: rotate(90deg);
            }
        }

        .step-how-where-container {
            flex-direction: column;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/StepEbonComponentStyle.js